import { useMemo } from 'react';
import { useTranslation } from '../../../hooks/i18n';
import { baseItems } from '../../../config/layout';

export const useMenuItems = () => {
  const { t } = useTranslation();

  const menuItems = useMemo(() => {
    const translatedItems = baseItems.map((item) => ({
      ...item,
      text: t(item.text)
    }));
    return translatedItems;
  }, [t]);

  return { menuItems };
};

